import { Component, computed, inject } from '@angular/core';
import { PurchaseListStore } from '../../../../stores/purchase-list.store';
import { PurchaseListItem } from '../../../../models/purchase-list-item';

/** Étape « Validation » du tunnel panier : récapitulatif de la liste d'achat. */
@Component({
  selector: 'ng-casto-basket-tunnel-validation',
  templateUrl: './basket-tunnel-validation.component.html',
  styleUrls: ['./basket-tunnel-validation.component.scss'],
})
export class BasketTunnelValidationComponent {
  protected readonly purchaseListStore = inject(PurchaseListStore);

  protected readonly items = computed(() => this.purchaseListStore.displayItems());

  /** Prix total d'une ligne de la liste d'achat. */
  protected getItemTotal(item: PurchaseListItem): number {
    return item.amount * item.product.price;
  }
}
